import { lazy, Suspense } from "react";
import type { AccountPickerProps } from "./AccountPickerField";

const AccountPickerField = lazy(() => import("./AccountPickerField"));
export type { AccountPickerProps } from "./AccountPickerField";

export default function AccountPicker(props: AccountPickerProps) {
  return <Suspense fallback={<span className="settings-note">{props.label}…</span>}>
    <AccountPickerField {...props} />
  </Suspense>;
}
